<template>
  <div class="row" v-if="can_access('customer','view')">
    <div class="col-md-12" style="display: block ruby;">
		  <h1 class="">Client Reports</h1>
      <!-- <b-form-select v-model="sheet" style="color:#000;font-weight:600" :options="options" class="col-md-2 pull-right mt-1"></b-form-select> -->
    </div>
    <div class="col-md-12">
      <TableView :col="columns" :getData="getData" v-if="can_access('customer','view') && !sheet"/>
      <!-- <MISDailyStatusReport v-else-if="sheet==1 && can_access('report','view')"/> -->
    </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import common from '@/assets/js/common.js';
import AddCustomerForm from '@/components/Accounts/AddCustomerForm';
import TableView from '@/components/Common/DataTable/Table';
//import MISDailyStatusReport from '@/components/Accounts/MISDailyStatusReport.vue';

export default {
  name: 'CustomersPage',
  components: { Widget, AddCustomerForm, TableView },
  mixins: [common],
  data() {
    return {
      sheet: '',
      /* options: [
        { value: '', text: 'BASIC REPORT' },
        { value: '1', text: 'MIS DAILY STATUS' },
      ], */
      showAddCustomerForm: false,
      errorMessage: null,
      columns: (() => {
        const cols = [
          { title: 'Accoun No.', field: 'account_number', label: 'User ID', thComp: 'FilterTh', sortable: true, visible: 'true' },
          { title: 'Title', field: 'title', thComp: 'FilterTh' },
          { title: 'Firstname', field: 'firstname', thComp: 'FilterTh', tdStyle: { fontStyle: 'italic' } },
          { title: 'Lastname', field: 'lastname', thComp: 'FilterTh', thStyle: { fontWeight: 'normal' } },
          { title: 'Email', field: 'email', thComp: 'FilterTh', tdComp: 'Email'},
          { title: 'Phone', field: 'phone_no', thComp: 'FilterTh'},
          { title: 'DOB/Incorporation Date', field: 'dob', sortable: true },
          { title: 'Operation', tdComp: 'reportOpt', visible: 'true', tdStyle:{'text-align':'center'}, thStyle:{'text-align':'center'} }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  methods: {
    customerFormReRender(response) {
      if(response.code==0){
        this.showAddCustomerForm = false;
        this.$nextTick(function(){
          this.showAddCustomerForm = true;
          this.$toasted.success("Successfully Added",{duration:1000});
        });
      }
    },
    async getData(query, filter) {
      var { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      //filter['has_trade'] = 1;
      filter['approved_at'] = {from_date:'2020-01-01'};
      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });

      let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      return await this.call_axios(uri);
    }
  },
  created() {
    
  },
};
</script>